export default __webpack_public_path__ + "static/media/08.356e2311.svg";